const NotificationContext = {
  LOGGED_IN: 'LOGGED_IN',
  SIMPLE_NOTIFICATION: 'SIMPLE_NOTIFICATION',
};

export default NotificationContext;
